import { FormGroup } from '@angular/forms';

export abstract class NovoSuprimentoFormProvider {
  abstract getForm(): FormGroup;
  abstract limparForm(): void;
}
